import React from "react";
import ViewButton from "components/button/viewbutton";
import DownloadButton from "components/button/download";
import DocumentInfo from "views/console/team-managements/employee-details/components/DocumentInfo";

const DocumentCard = ({
    icon,
    documentData,
}) => {

    const statusText = documentData?.doc_status_name ? String(documentData?.doc_status_name) : "Active";
    const statusClass = statusText.toLowerCase().replace(/\s+/g, "-");

    return (
        <>
            <div className="bg-white flex flex-col gap-6 rounded-xl border hover:shadow-md border-slate-200 dark-mode-card">
                <div className="p-4 pb-6">
                    <div className="flex items-start gap-4">
                    <div className="p-3 rounded-lg bg-slate-50 border border-slate-200">
                        {icon}
                    </div>

                    <div className="flex-1 min-w-0">
                        <div className="flex items-start justify-between gap-2 mb-2">
                            <h4 className="font-semibold text-[14px] title-text">{documentData?.doc_title}</h4>
                            <span className={`status-docs ${statusClass}`}>
                                {statusText}
                            </span>

                            </div>
                            <p className="text-[12px] mb-3 muted-text">
                                {documentData?.doc_description}
                            </p>

                            <div className="flex items-center justify-between">
                                <div className="flex items-center gap-4 text-[12px] muted-text">
                                    <span>{documentData?.doc_date}</span>
                                    <span>•</span>
                                    <span>{documentData?.attachment?.formatted_size}</span>
                                </div>

                                <div className="flex items-center gap-2">
                                    <ViewButton>
                                        <DocumentInfo document={documentData} />
                                    </ViewButton>

                                    <DownloadButton 
                                        className="text-black font-medium border bg-gradient-to-r from-white to-white hover:bg-slate-50 hover:shadow-none rounded-lg gap-1.5 h-8 px-3 text-[12px] hover:from-gray-100 hover:to-gray-100 hover:shadow-brandShadow/50" 
                                        title="Preview"
                                        type="preview"
                                        attachmentData={documentData?.attachment}/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default DocumentCard;
